import {Order} from '../../types';
import {orderStatuses} from '../../static_data/orderStatuses';

export function isDeleted(order : Order) : boolean {
    if(order.orderStatus === orderStatuses.DELETED.key) return true;
    return false;
}